import React, { useEffect, useState } from "react";
import { Autocomplete, createFilterOptions, TextField } from "@mui/material";
import FormFieldError from "components/common/form_error/form_field_error";

const FormAutoComplete = ({
  label,
  value,
  errorMessage,
  options = [],
  maxLength = null,
  hasError = false,
  required = false,
  handleInputChange,
  variant = "outlined",
  submitClicked = true,
}) => {
  const filter = createFilterOptions();
  const [error, setError] = useState(false);

  useEffect(() => {
    setError(required && value === "" && submitClicked);
  }, [required, value, submitClicked]);

  const getOptionValue = (option) => {
    return typeof option === "string"
      ? option
      : option?.inputValue || option?.title || option || "";
  };

  return (
    <>
      <Autocomplete
        freeSolo
        fullWidth
        clearOnBlur
        selectOnFocus
        value={value}
        error={error}
        name="modelName"
        handleHomeEndKeys
        openOnFocus={true}
        renderOption={(props, option) => (
          <li {...props} key={option.inputValue}>
            {option.title}
          </li>
        )}
        options={options.map((option) => ({
          inputValue: option,
          title: option,
        }))}
        filterOptions={(options, params) => {
          const filtered = filter(options, params);

          if (params.inputValue !== "") {
            filtered.unshift({
              inputValue: params.inputValue,
              title: `+ Add "${params.inputValue}"`,
            });
          }

          return filtered;
        }}
        getOptionLabel={getOptionValue}
        isOptionEqualToValue={(option, val) =>
          getOptionValue(option) === getOptionValue(val)
        }
        onChange={(_event, newValue) => {
          handleInputChange(getOptionValue(newValue));
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            required
            value={value}
            label={label}
            variant={variant}
            error={error || hasError}
            inputProps={{
              ...params.inputProps,
              readOnly: false,
              maxLength: maxLength,
            }}
          />
        )}
      />

      <div className="mt-2">
        {(error || hasError) && (
          <FormFieldError
            errorMessage={errorMessage || `${label} is required.`}
          />
        )}
      </div>
    </>
  );
};

export default FormAutoComplete;
